/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts";
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize";
import { IHasDimentions, IScreenModes } from "../data/interfaces";

export default function useComponentData<T extends IHasDimentions>(componentData:T): T {
    const { width } = useScreenSize()
    const dimentions: IScreenModes = componentData.dimentions || {}
    const [ data, setData ] = useState<T>(componentData)
    useEffect(() => {
        let _data: T = {} as T 
        switch(true) {
            case width > WINDOW_WIDTH.PANEL:             
                _data = ({ ...componentData, ...dimentions[WINDOW_WIDTH.PANEL]?.data})
                break
            case width > WINDOW_WIDTH.LARGE:            
                _data = ({ ...componentData, ...dimentions[WINDOW_WIDTH.LARGE]?.data})
                break
            case width > WINDOW_WIDTH.SCREEN:             
                _data = ({ ...componentData, ...dimentions[WINDOW_WIDTH.SCREEN]?.data})
                break
            case width > WINDOW_WIDTH.TABLET:            
                _data = ({ ...componentData, ...dimentions[WINDOW_WIDTH.TABLET]?.data})
                break
            case width > WINDOW_WIDTH.MOBILE:           
                _data = ({ ...componentData, ...dimentions[WINDOW_WIDTH.MOBILE]?.data})
                break
            case width > WINDOW_WIDTH.SMALL: 
                _data = ({ ...componentData, ...dimentions[WINDOW_WIDTH.SMALL]?.data})
                break
        } 
        setData( _data )
    }, [width, componentData])
    return data
}